import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { useSelfService } from '../../hooks/useSelfService';
import PayslipCard from '../../components/PayslipCard';

const SelfServicePayslipDetailView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { activePayslip, loading, fetchPayslip } = useSelfService();

  useEffect(() => {
    if (id) fetchPayslip(Number(id));
  }, [id]);

  if (loading || !activePayslip) return <Spin className="p-6" />;

  return (
    <div className="p-6">
      <PayslipCard entry={activePayslip} />
    </div>
  );
};

export default SelfServicePayslipDetailView;
